<template>
  <v-card>
    <v-card-title>Recent Activity</v-card-title>
    <v-card-text>
      <div v-if="loading" class="loading">Loading...</div>
      <div v-else-if="recentRequests.length === 0" class="empty">
        No recent activity
      </div>
      <div v-else class="activity-list">
        <div v-for="request in recentRequests" :key="request.id" class="activity-item">
          <div class="activity-icon">📋</div>
          <div class="activity-details">
            <div class="activity-title">{{ request.student_name || 'New request' }}</div>
            <div class="activity-meta">{{ request.school_name || request.school }} • {{ request.grade_level }}</div>
          </div>
          <div class="activity-status" :class="`status-${request.status}`">
            {{ formatStatus(request.status) }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
interface Request {
  id: string
  student_name?: string
  school: string
  school_name?: string
  grade_level: string
  status: string
}

interface Props {
  recentRequests: Request[]
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  recentRequests: () => [],
  loading: false
})

const formatStatus = (status: string) => {
  return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.loading,
.empty {
  text-align: center;
  padding: 2rem;
  color: var(--text-light, #666666);
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.activity-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--light-bg, #f5f7fa);
  border-radius: 6px;
}

.activity-icon {
  font-size: 1.5rem;
}

.activity-details {
  flex: 1;
}

.activity-title {
  font-weight: 600;
  color: var(--text-dark, #333333);
  margin-bottom: 0.25rem;
}

.activity-meta {
  font-size: 0.85rem;
  color: var(--text-light, #666666);
}

.activity-status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: capitalize;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-fulfilled {
  background: #d4edda;
  color: #155724;
}

.status-under_review {
  background: #d1ecf1;
  color: #0c5460;
}
</style>
